export default __webpack_public_path__ + "static/media/factory_configuration_hero.f2cd38a5.jpg";